import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Video } from '@planone/shared/util-interfaces';

@Component({
  selector: 'planone-video-swiper-zoom-modal',
  templateUrl: './video-swiper-zoom-modal.component.html',
  styleUrls: ['./video-swiper-zoom-modal.component.scss'],
})
export class VideoSwiperZoomModalComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      video?: Video;
      title?: string;
      index?: number;
    }
  ) {}

  ngOnInit() {
    Array.prototype.forEach.call(document.getElementsByClassName('mat-toolbar'), (el) => {
      el.classList.add('blurred');
    });

    Array.prototype.forEach.call(document.getElementsByClassName('mat-drawer-content'), (el) => {
      el.classList.add('blurred');
    });
  }

  ngOnDestroy() {
    Array.prototype.forEach.call(document.getElementsByClassName('mat-toolbar'), (el) => {
      el.classList.remove('blurred');
    });

    Array.prototype.forEach.call(document.getElementsByClassName('mat-drawer-content'), (el) => {
      el.classList.remove('blurred');
    });
  }
}
